import { applyMiddleware, createStore, compose, combineReducers } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import history from '../modules/history';
import rootSaga from '../sagas';
import {
  appReducer,
  sessionReducer,
  pageReducer,
  activityReducer,
  domainReducer,
  galleryReducer,
  profileReducer,
  planReducer,
  paymentReducer,
  editorReducer,
  leadReducer,
} from '../reducers';

const sagaMiddleware = createSagaMiddleware();

const rootPersistConfig = {
  key: 'root', // key is required
  storage, // storage is now required
  whitelist: [
    'app',
  ],
};

const sessionPersistConfig = {
  key: 'session',
  storage,
  blacklist: ['status'],
  whitelist: ['isAuthenticated', 'token', 'fcmToken'],
};

const profilePersistConfig = {
  key: 'profile',
  storage,
  blacklist: ['status'],
  whitelist: ['profile'],
};

const reducer = persistReducer(
  rootPersistConfig,
  combineReducers({
    app: appReducer,
    session: persistReducer(sessionPersistConfig, sessionReducer),

    profile: persistReducer(profilePersistConfig, profileReducer),
    payment: paymentReducer,
    plan: planReducer,

    page: pageReducer,
    activity: activityReducer,
    domain: domainReducer,
    gallery: galleryReducer,
    editor: editorReducer,
    lead: leadReducer,

    router: routerReducer,
  })
);

const middleware = [
  sagaMiddleware,
  routerMiddleware(history),
];

/* istanbul ignore next */
if (process.env.NODE_ENV === 'development') {
  const { createLogger } = require('redux-logger');
  middleware.push(createLogger({ collapsed: true }));
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

/* istanbul ignore next */
const configStore = (initialState = {}) => {
  const createStoreWithMiddleware = composeEnhancers(applyMiddleware(...middleware))(createStore);

  const store = createStoreWithMiddleware(reducer, initialState);

  sagaMiddleware.run(rootSaga);

  if (module.hot) {
    module.hot.accept('reducers', () => {
      store.replaceReducer(require('reducers').default);
    });
  }

  return {
    persistor: persistStore(store),
    store,
  };
};

const { store, persistor } = configStore();

export { store, persistor };



// WEBPACK FOOTER //
// ./scripts/store/index.js